/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load.`)
};

const es_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar.`)
};

const de_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden fehlgeschlagen.`)
};

const nl_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden mislukt.`)
};

const fr_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement.`)
};

const it_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento non riuscito.`)
};

const pt_br2_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar.`)
};

const pt_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar.`)
};

const ja_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込みに失敗しました。`)
};

const zh_admin_load_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载失败。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const admin_load_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.admin_load_error(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("admin_load_error", locale)
	if (locale === "en") return en_admin_load_error(inputs)
	if (locale === "es") return es_admin_load_error(inputs)
	if (locale === "de") return de_admin_load_error(inputs)
	if (locale === "nl") return nl_admin_load_error(inputs)
	if (locale === "fr") return fr_admin_load_error(inputs)
	if (locale === "it") return it_admin_load_error(inputs)
	if (locale === "pt-BR") return pt_br2_admin_load_error(inputs)
	if (locale === "pt") return pt_admin_load_error(inputs)
	if (locale === "ja") return ja_admin_load_error(inputs)
	return zh_admin_load_error(inputs)
};